import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "inspect-single",
  "use": "inspect-single-usage",
  "viewBox": "0 0 37.55 46.39",
  "content": "<symbol viewBox=\"0 0 37.55 46.39\" id=\"inspect-single\"><title>资源 25</title><g id=\"inspect-single_图层_2\" data-name=\"图层 2\"><g id=\"inspect-single_图层_1-2\" data-name=\"图层 1\"><path d=\"M34.24,0H3.31A3.31,3.31,0,0,0,0,3.31V43.07a3.31,3.31,0,0,0,3.31,3.31H34.24a3.31,3.31,0,0,0,3.31-3.31V3.31A3.31,3.31,0,0,0,34.24,0ZM6.85,9.66a1.66,1.66,0,0,1,1.43-.83h8.84a1.66,1.66,0,0,1,0,3.31H8.28A1.66,1.66,0,0,1,6.85,9.66Zm0,6.63a1.66,1.66,0,0,1,1.43-.83h8.84a1.66,1.66,0,1,1,0,3.31H8.28a1.66,1.66,0,0,1-1.43-2.48ZM30.7,36.72a1.66,1.66,0,0,1-1.43.83h-21a1.66,1.66,0,1,1,0-3.31h21a1.66,1.66,0,0,1,1.43,2.49Zm0-6.63a1.66,1.66,0,0,1-1.43.83h-21a1.66,1.66,0,1,1,0-3.31h21A1.66,1.66,0,0,1,30.7,30.1Zm.22-12.43a1.1,1.1,0,0,1-1.1,1.1H23.19a1.1,1.1,0,0,1-1.1-1.1V9.94a1.1,1.1,0,0,1,1.1-1.1h6.63a1.1,1.1,0,0,1,1.1,1.1Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/inspect-single.svg
// module id = eh8I
// module chunks = 264